<template>
  <b-table v-bind="tableAttributes" :fields="fields" :items="items">

    <template #cell(name)="data">
      {{ data.item.name }}
    </template>

    <template #cell(thumbnail)="data">
      <b-img :src="data.item.thumbnail" v-bind="mainProps"/>
    </template>

    <template #cell(price)="data">
      <update-quantity-price-offer :product="data.item" mode="price"/>
      <update-quantity-price-offer :product="data.item" mode="offer"/>
    </template>

    <template #cell(status)="data">
      <status-changer :item="data.item" item-type="product"/>
    </template>

    <template #cell(quantity)="data">
      <div v-if="data.item.variation == 0">
        <update-quantity-price-offer :product="data.item" mode="quantity"/>
      </div>
      <div v-else>
        <span>-</span>
      </div>
    </template>

    <template #cell(brand)="data">
      <b-badge variant="info" class="text-wrap" v-if="data.item.is_digital==0 && data.item.brand">
        {{ data.item.brand.name }}
      </b-badge>
    </template>

    <template #cell(is_digital)="data">
      <b-badge variant="info" class="text-wrap">
        {{ data.item.is_digital == 0 ? 'فیزیکی' : 'دیجیتال' }}
      </b-badge>
    </template>

    <template #cell(category)="data">
      <span v-for="el in data.item.category">
        <b-badge variant="warning" class="text-wrap d-block mt-2">{{ el.name }}</b-badge>
      </span>
    </template>

    <template #cell(action)="data">
      <div class="text-nowrap ml-3">
      <span
          class="h5"
          v-b-tooltip.hover
          title="حذف دائمی"
          v-if="restoreState == true"
      >
        <b-icon icon="trash" @click="ForceDeleteProduct(data.item)"></b-icon>
      </span>

        <span class="h5" v-b-tooltip.hover title="حذف" v-else>
        <b-icon icon="trash" @click="deleteProduct(data.item)"></b-icon>
      </span>

        <span
            class="h5"
            v-b-tooltip.hover
            title="بازگردانی"
            v-if="restoreState == true"
        >
        <b-icon
            icon="arrow-clockwise"
            class="mr-3"
            @click="restore(data.item)"
        ></b-icon>
      </span>

        <span class="h5" v-b-tooltip.hover title="ویرایش" v-else>
        <router-link
            :to="{ name: 'EditProduct', params: { slug: data.item.raw_link } }"
        >
          <b-icon icon="pencil" class="mr-3"></b-icon>
        </router-link>
      </span>
      </div>
    </template>
  </b-table>
</template>

<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {getProductPrice} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import UpdateQuantityPriceOffer from "./UpdateQuantityPriceOffer";
import StatusChanger from "../../StatusChanger";

export default {
  name: "tableItems",
  props: ["items", "restoreState"],
  components: {UpdateQuantityPriceOffer, StatusChanger},
  data() {
    return {
      tableAttributes: {...tableAttributes, ...{responsive: true}},
      fields: [
        {key: "name", label: "نام"},
        {key: "thumbnail", label: "عکس"},
        {key: "price", label: "قیمت"},
        {key: "status", label: "وضعیت"},
        {key: "quantity", label: "تعداد"},
        {key: "brand", label: "برند"},
        {key: "is_digital", label: "نوع محصول"},
        {key: "category", label: "دسته بندی"},
        {key: "action", label: "#"},
      ],
      mainProps: {width: 80, height: 80, class: 'p-0 rounded'}
    };
  },
  methods: {
    formatNumber,
    getProductPrice,
    deleteProduct(item) {
      if (confirm('آیا از حذف این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Product/deleteProduct", item);
      }
    },
    restore(product) {
      if (confirm('آیا از بازگردانی این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Product/restoreProduct", product);
      }
    },
    ForceDeleteProduct(product) {
      if (confirm('آیا از حذف دائمی این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Product/forceDeleteProduct", product);
      }
    },
  },
};
</script>